var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"core-embed"},[_c('video-embed',{attrs:{"src":_vm.block.attrs.url,"css":_vm.aspectClass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }